import React from "react";

import { PickupRequestListItem } from "../../../../types";

import TwoLineGridCell from "../TwoLineGridCell";

interface Props {
  data: PickupRequestListItem;
}

// Hauler view: the target company is always the caller, so the column shows where the pickup is
// from - the mirror of HaulerCompanyGridCell, which the collector view uses.
const CollectorCompanyGridCell = ({ data }: Props) => (
  <TwoLineGridCell
    firstLineData={data.sourceCompanyName}
    secondLineData={data.sourceCompanyRegNumber}
  />
);

export default CollectorCompanyGridCell;
